import * as React from 'reactn';
import {ArrayUtil, ComponentFactory, dialog, IBaseDialogProps, LocalCache, SelectItem} from "oca-lib-web";
import AnalyticsEngine from "../data/AnalyticsEngine";
import DashboardDateUtil from "../util/DashboardDateUtil";
import EventUtil from "../util/EventUtil";
import Styles from "../style/Styles";
import DataMappingUtil from "../util/DataMappingUtil";
import CacheSettings from '../util/CacheSettings';

interface IState {
    componentFactory:ComponentFactory,
    dataset:Array<any>,
    columnHeaders:Array<SelectItem>,
    headers:Array<string>,
    param:any
}

/* Selection drill down dialog */
class SelectedValuesDialog extends React.Component<IBaseDialogProps, IState> {

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(this.global.dataManager, null, {});
        componentFactory.setHandleUpdateCallback((value:any, key:any) => {
            if (key == "selectedValues") {
                this.updateFields();
            } else if (key == "groupBy") {
                this.groupData();
            }
        });

        this.state = {
            componentFactory:componentFactory,
            dataset:[],
            columnHeaders:[],
            headers:[],
            param: props.param
        };
        props.dialog.saveFunction(this.handleSave.bind(this));
    }

    async componentWillMount() {
        //let param = param;
        let graphSettingsItem = this.state.param.graphSettingItem;
        let selectionData = this.state.param.data;
        console.log(selectionData);

        var projectId = CacheSettings.getCurrentProject();
        let dataMappings = await DataMappingUtil.getDataMappings(projectId);
        let dataset:Array<any> = [];
        let columnHeaders:Array<SelectItem> = [];
        let headers:Array<string> = [];
        let data = AnalyticsEngine.getData(graphSettingsItem, DashboardDateUtil.getTimeInterval());
        console.log(data);
        console.log(graphSettingsItem);
        console.log(DashboardDateUtil.getTimeInterval())

        // load column headers if they are saved

        for (let dataItem of data) {
            if (dataItem[graphSettingsItem.xAxis] == selectionData[graphSettingsItem.xAxis]) {
                dataset.push(dataItem);
            } else if (EventUtil.hasParam(dataItem, graphSettingsItem.xAxis)) {
                let paramValue = EventUtil.getParamValue(dataItem, graphSettingsItem.xAxis);
                if (paramValue == selectionData[graphSettingsItem.xAxis]) {
                    dataset.push(dataItem);
                }
            }

            if (columnHeaders.length == 0) {
                let keys = Object.keys(dataItem);
                for (let key of keys) {
                    if (key == "paramValue") {
                        let paramValueObject = dataItem[key];
                        let paramValueKeys = Object.keys(paramValueObject);
                        for (let paramValueKey of paramValueKeys) {
                            columnHeaders.push(SelectItem.create(paramValueKey, DataMappingUtil.replaceData(paramValueKey, dataMappings)));
                            headers.push(paramValueKey);
                        }
                    } else {
                        headers.push(key);
                        columnHeaders.push(SelectItem.create(key, DataMappingUtil.replaceData(key, dataMappings)))
                    }
                }
            }
        }
        ArrayUtil.sort(columnHeaders, "label");
        ArrayUtil.sort(headers);

        let selectedValues = LocalCache.getLocal("selectedValues_" + graphSettingsItem.id);
        if (selectedValues) {
            headers = [];
            console.log("found selected values: " + selectedValues);
            this.state.componentFactory.getDefaultBinding().setProperty("selectedValues", selectedValues);
            let selectedValuesArray = selectedValues.split(",");
            for (let selectedValue of selectedValuesArray) {
                headers.push(selectedValue);
                //columnHeaders.push(SelectItem.create(selectedValue, DataMappingUtil.replaceData(selectedValue, dataMappings)))
            }
        } else {
            this.state.componentFactory.getDefaultBinding().setProperty("selectedValues", headers.join(","));
        }

        this.setState({dataset:dataset, columnHeaders:columnHeaders, headers:headers}, function(this:SelectedValuesDialog) {
            this.forceUpdate();
        }.bind(this));
    }

    groupData() {
        let newDataset:any[] = [];
        let groupBy = this.state.componentFactory.getDefaultBinding().getProperty("groupBy");
        for (let dataItem of this.state.dataset) {
            let foundInNewDataset = false;
            for (let newDataItem of newDataset) {
                let found = false;
                if (dataItem[groupBy] && dataItem[groupBy] == newDataItem[groupBy]) {
                    found = true;
                } else if (EventUtil.hasParam(dataItem, groupBy)) {
                    let dataItemParamValue = EventUtil.getParamValue(dataItem, groupBy);
                    let newDataItemParamValue = EventUtil.getParamValue(newDataItem, groupBy);
                    //console.log(dataItemParamValue);
                    //console.log(newDataItemParamValue);
                    if (dataItemParamValue == newDataItemParamValue) {
                        found = true;
                    }
                }

                if (found) {
                    let graphSettingsItem = this.state.param.graphSettingItem;
                    let metrics = graphSettingsItem.metric.split(",");
                    for (let metricItem of metrics) {
                        if (!newDataItem[metricItem]) {
                            newDataItem[metricItem] = 0;
                        }
                        newDataItem[metricItem] += parseInt(dataItem[metricItem]);
                    }
                    foundInNewDataset = true;
                }
            }

            if (!foundInNewDataset) {
                newDataset.push(dataItem);
            }
        }

        this.setState({dataset:newDataset}, function(this:SelectedValuesDialog) {
            this.forceUpdate();
        }.bind(this));
    }

    // Action methods

    async handleSave(callback:any) {
        let cf = this.state.componentFactory;
        let graphSettingsItem = this.state.param.graphSettingItem;
        let selectedValues = cf.getDefaultBinding().getProperty("selectedValues");
        console.log(graphSettingsItem);
        console.log(selectedValues);
        LocalCache.saveLocal("selectedValues_" + graphSettingsItem.id, selectedValues);
        //console.log(componentBinding.item);
        callback(cf.getDefaultBinding().item);
    }

    updateFields() {
        let selectedValues = this.state.componentFactory.getDefaultBinding().getProperty("selectedValues");
        let selectedValueList = selectedValues.split(",");
        this.setState({headers:selectedValueList}, function(this:SelectedValuesDialog) {
            this.forceUpdate();
        }.bind(this));
    }

    // Render methods

    renderReportRow(item:any) {
        let columns = [];
        //let keys = Object.keys(item);
        let keys = this.state.headers;
        for (let key of keys) {
            if (EventUtil.hasParam(item, key)) {
                let paramValue = EventUtil.getParamValue(item, key);
                columns.push(paramValue);
            } else {
                columns.push(item[key]);
            }
        }
        //console.log(columns);
        return columns;
    }

    public render() {
        const cf = this.state.componentFactory;
        let rows = this.state.dataset.length > 0 ? this.state.dataset : []

        return cf.renderBox([
            cf.renderBoxProps({marginBottom:'20px'},
                cf.renderHorizontalLayout([
                    cf.renderSelectField("selectedValues", "Available columns", this.state.columnHeaders, null, null, {multiple:true}),
                    cf.renderBox(null),
                    cf.renderSelectField("groupBy", "Group by", this.state.columnHeaders, null, null, {multiple:false})
                ], ['48%','2%','48%'])
            ),
            cf.renderTable(this.state.headers, rows, this.renderReportRow.bind(this))
        ]);
    }
}

export default dialog(SelectedValuesDialog)